// Core libraries
import React from 'react';

// External libs and components
// import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router';

// Internal libs

// Internal components
import PageDefaultLayout from '@common/components/layouts/PageDefaultLayout';
import RidesCard from './RidesCard';
import RideModal from './RideModal';

// // Styles hook
// const useStyles = makeStyles((theme) =>
//   createStyles({
//     root: {},
//   }),
// );

// Props type
type RidesPageProps = {};

// Component
const RidesPage = ({}: RidesPageProps) => {
  const { t } = useTranslation('rides');
  // const styles = useStyles();
  const { path } = useRouteMatch();
  const history = useHistory();

  return (
    <PageDefaultLayout title={t('title')}>
      <RidesCard />

      <Switch>
        <Route path={`${path}/ride/:rideId`}>
          <RideModal onClose={() => history.push(path)} />
        </Route>
      </Switch>
    </PageDefaultLayout>
  );
};

export default RidesPage;
